import React from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import { showMenu } from "../../actions";

class MobileSection extends React.Component {
  hideMenu = (e) => {
    if (e.target.classList.contains("menu__body")) {
      this.props.showMenu();
    }
  };

  renderMobFullInput = (formProps) => {
    return (
      <div className="header__filter--input--full--mobile">
        <div className="header__filter--input--box--wrapper">
          <input
            autocomplete="off"
            {...formProps.input}
            id="fulltime"
            type="checkbox"
            className={`checkbox--hidden checkbox--hidden--mobile`}
            value={false}
          />
          <label
            htmlFor="fulltime"
            className={`checkbox checkbox--mobile ${
              formProps.darkMode ? "dark--2" : ""
            }`}
          ></label>
          <label
            className={` ${formProps.darkMode ? "white" : ""}`}
            htmlFor={`fulltime`}
          >
            {formProps.label}
          </label>
        </div>
        <button className="btn btn--form--mobile" type="submit">
          Search
        </button>
      </div>
    );
  };

  renderMobLocInput = (formProps) => {
    return (
      <div className="header__filter--input--mob--box">
        <input
          autocomplete="off"
          {...formProps.input}
          className={`header__filter--input--loc header__filter--input--mob ${
            formProps.darkMode ? "dark--3 dark__color" : ""
          }`}
          placeholder="Filter by location..."
        />
      </div>
    );
  };
  renderMenu = () => {
    if (!this.props.menu) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="menu__body" ref={this.modalRef} onClick={this.hideMenu}>
          <div
            className={`menu__content ${this.props.darkMode ? "dark--3" : ""} `}
          >
            <Field
              name="location"
              component={this.renderMobLocInput}
              darkMode={this.props.darkMode}
            />
            <Field
              name="fulltime"
              component={this.renderMobFullInput}
              label="Full Time"
              type="checkbox"
              darkMode={this.props.darkMode}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    return <React.Fragment>{this.renderMenu()}</React.Fragment>;
  }
}

const mapStateToProps = (state) => {
  return {
    darkMode: state.darkMode,
    menu: state.menu,
  };
};

export default connect(mapStateToProps, { showMenu })(MobileSection);
